//#region src/Tag/hexToRgba.ts
function hexToRgba(hex, opacity) {
	hex = hex.replace("#", "");
	return `rgba(${parseInt(hex.substring(0, 2), 16)}, ${parseInt(hex.substring(2, 4), 16)}, ${parseInt(hex.substring(4, 6), 16)}, ${opacity})`;
}
//#endregion
export { hexToRgba };

//# sourceMappingURL=hexToRgba.js.map